import React from 'react';
import Button from '../../controls/Button';
import BaseModal from '../BaseModal';

/**
 *
 * @param {{
 *  show?:boolean;
 *  confirmModalInfo:string;
 *  title:string;
 *  buttonConfirmText?:string;
 *  buttonCancelText?:string;
 *  onClose?(r:{result:boolean;}):void;
 *  isBusy?:boolean;
 * }} props
 * @returns {React.ReactElement|null}
 */
export const ConfirmModal = props => {
  const {
    show,
    onClose,
    confirmModalInfo,
    title,
    isBusy,
    buttonCancelText = 'Cancel',
    buttonConfirmText = 'Confirm',
  } = props;

  const modalBody = () => {
    return (
      <>
        {confirmModalInfo ? (
          <p tabIndex={0} className="mb-2">
            {confirmModalInfo}
          </p>
        ) : (
          ''
        )}
      </>
    );
  };

  const modalControls = () => {
    return (
      <>
        <Button onClick={onCloseProxy(false)} outline primary>
          {buttonCancelText}
        </Button>
        <Button onClick={onCloseProxy(true)} danger>
          {buttonConfirmText}
        </Button>
      </>
    );
  };
  /**
   *
   * @param {boolean} result
   * @returns
   */
  const onCloseProxy =
    (result = false) =>
    () =>
      onClose?.({ result });

  return (
    <BaseModal
      isBusy={isBusy}
      show={show}
      title={title}
      body={modalBody()}
      controls={modalControls()}
      modalBodyClass={'text-center'}
    />
  );
};

export default ConfirmModal;
